import { useContext } from 'react';
import { StoreContext } from '@roc/feature-app-core';
import { BorrowerTrackRecordStore } from '../stores/';

export const useBorrowerTrackRecordStore = () => useContext<{
  borrowerTrackRecordStore: BorrowerTrackRecordStore
}>(StoreContext);
